export const generateVideoSnapshot = async (videoUrl: string, captureTimeInSeconds: number): Promise<string> => {
    return new Promise((resolve, reject) => {
        const video = document.createElement('video');
        video.src = videoUrl;

        video.addEventListener('loadeddata', () => {
            const canvas = document.createElement('canvas');
            const context = canvas.getContext('2d');

            const captureTime = Math.min(captureTimeInSeconds, video.duration);
            video.currentTime = captureTime;

            const videoWidth = video.videoWidth;
            const videoHeight = video.videoHeight;
            const targetHeight = 100;

            const scale = targetHeight / videoHeight;
            const targetWidth = videoWidth * scale;

            canvas.width = targetWidth;
            canvas.height = targetHeight;

            context!.drawImage(video, 0, 0, targetWidth, targetHeight);

            const dataUrl = canvas.toDataURL();
            resolve(dataUrl);
        });

        video.addEventListener('error', error => {
            reject(error);
        });

        video.load();
    });
};
